/// <amd-module name="VSS/Platform/RestClient/CustomerIntelligence" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   webplatform\web\extensions\vss-web\vss-platform\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "../Context";
import { RestClientBase } from "../RestClientBase";

import * as CustomerIntelligence from "../Contracts/CustomerIntelligence";

import { ICustomerIntelligenceRestClient } from "VSS/Platform/RestClient/CustomerIntelligence.Types";

export { ICustomerIntelligenceRestClient } from "VSS/Platform/RestClient/CustomerIntelligence.Types";

class CustomerIntelligenceRestClient extends RestClientBase implements ICustomerIntelligenceRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param events - 
     */
    public async publishEvents(
        events: CustomerIntelligence.CustomerIntelligenceEvent[]
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/customerintelligence/Events",
            body: events
        });
    }

}

export const CustomerIntelligenceClientName = "ICustomerIntelligenceRestClient";

export function getCustomerIntelligenceClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ICustomerIntelligenceRestClient {
    return pageContext.getRestClient<ICustomerIntelligenceRestClient>(CustomerIntelligenceClientName, options);
}

RestClients.add(CustomerIntelligenceClientName, { 
    factory: CustomerIntelligenceRestClient
});
